export const report = `
  uuid
  userUuid
  tenantUuid
  createdAt
  completedAt
  failedAt
  reportType
  exportType
  status
  resultFileUrl
  error{
    code
  }
  data {
    to
    from
    teamUuid
    displayTimezone
    team {
      public_name
    }
    cycleId
    cycle {
      reference
    }
    tenantUuid
    driverId
    driver {
      contentId
    }
  }
`
export default report
